export const ftpErrors = {
  FTP_CLIENT_FAILURE: {
    status: 401,
    code: 'FTP_CLIENT_FAILURE',
    title: 'FTP Client Error',
    subtitle: 'FTP CLIENT ERROR',
    description: 'There was an issue authenticating the FTP client. Please verify the credentials and try logging in again. If the problem persists, contact support for further assistance.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error typically occurs when the FTP client fails to authenticate, likely due to invalid credentials or misconfigurations. Check the FTP client settings and verify that the credentials are correct and up to date.',
          link: { text: 'Learn More', url: 'https://docs.mindcloud.co/docs/ftp-auth' }
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_LIST_FAILURE: {
    status: 500,
    code: 'FTP_LIST_FAILURE',
    title: 'FTP List Error',
    subtitle: 'FTP LIST ERROR',
    description: 'Unable to list the directory. Please verify the directory path and server availability, then try again.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when a directory listing fails. Common causes include: incorrect path (FTP/SFTP servers are often case-sensitive), insufficient permissions, transient network issues, or server-side restrictions/timeouts.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_DOWNLOAD_NO_PATH: {
    status: 400,
    code: 'FTP_DOWNLOAD_NO_PATH',
    title: 'Missing Download Path',
    subtitle: 'MISSING DOWNLOAD PATH',
    description: 'No file path was provided for the download operation. Please specify a valid remote path and try again.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when a download is attempted without a path. Provide the full remote path to the file you intend to download.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_RENAME_INVALID_ARGUMENTS: {
    status: 400,
    code: 'FTP_RENAME_INVALID_ARGUMENTS',
    title: 'Invalid Rename Arguments',
    subtitle: 'INVALID RENAME ARGUMENTS',
    description: 'Both the current file path and the new path are required to rename a file. Please provide both values and try again.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when a rename operation is attempted without both the source path and the destination path. Ensure both fields are provided and valid.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_UPLOAD_FAILURE: {
    status: 500,
    code: 'FTP_UPLOAD_FAILURE',
    title: 'FTP Upload Error',
    subtitle: 'FTP UPLOAD ERROR',
    description: 'An issue occurred while attempting to upload a file. Please verify the FTP configuration and try again. If the problem continues, contact support for assistance.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error can occur when the FTP client is misconfigured or encounters a network issue during file upload. Ensure that the FTP client configuration is correct and that the connection is stable.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_UPLOAD_NO_CONTENTS: {
    status: 400,
    code: 'FTP_UPLOAD_NO_CONTENTS',
    title: 'Empty File Upload',
    subtitle: 'NO CONTENTS TO UPLOAD',
    description: 'The file you attempted to upload contains no data. Please verify the file contents and try again.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when an empty file or a file with no contents is attempted to be uploaded via FTP. Ensure that the file contains valid data before attempting the upload.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_RENAME_FAILURE: {
    status: 500,
    code: 'FTP_RENAME_FAILURE',
    title: 'FTP Rename Error',
    subtitle: 'FTP RENAME ERROR',
    description: 'Unable to rename the file. This could be due to several reasons: the file may not exist at the specified path, the file might be locked, or the target filename may already exist. Please verify the file path and permissions, ensure the file is not in use, and check that the new filename is not already taken.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when a file rename operation fails. Common causes include: incorrect file path (FTP servers are case-sensitive), insufficient permissions (check write/modify permissions), file being locked or in use, target filename already existing, or server configuration disabling rename operations. For shared hosting, contact support to verify rename operations are enabled.'
        }
      }
    },
    component: 'DefaultErrorPage'
  },
  FTP_DOWNLOAD_FAILURE: {
    status: 500,
    code: 'FTP_DOWNLOAD_FAILURE',
    title: 'FTP Download Error',
    subtitle: 'FTP DOWNLOAD ERROR',
    description: 'Unable to download the file. This could be due to several reasons: the file may not exist at the specified path or there could be network connectivity issues. Please verify the file path, ensure the file is not in use, and verify your network connection.',
    roles: {
      admin: {
        about: {
          title: 'More on this error',
          description: 'This error occurs when a file download operation fails. Common causes include: incorrect file path (FTP servers are case-sensitive), insufficient read permissions, file being locked or in use, network connectivity issues, or server configuration problems. For large files, check if there are any size limits or timeout settings that might be affecting the download.'
        }
      }
    },
    component: 'DefaultErrorPage'
  }
};
